import { render, staticRenderFns } from "./temporaryPropertyDeposit.vue?vue&type=template&id=4f0a2540&scoped=true"
import script from "./temporaryPropertyDeposit.vue?vue&type=script&lang=js"
export * from "./temporaryPropertyDeposit.vue?vue&type=script&lang=js"
import style0 from "./temporaryPropertyDeposit.vue?vue&type=style&index=0&id=4f0a2540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a2540",
  null
  
)

export default component.exports